import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSearchFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.4896 13.022L12.233 9.76547C12.79 8.78528 13.082 7.68249 13.082 6.54088C13.082 2.93438 10.1478 0 6.54082 0C2.93382 0 0 2.93404 0 6.54054C0 10.147 2.93416 13.0814 6.54116 13.0814C7.68282 13.0814 8.78601 12.7895 9.76589 12.2324L13.0226 15.489C13.3519 15.8183 13.7902 16 14.2563 16C14.7223 16 15.1602 15.8187 15.49 15.489C16.17 14.8089 16.17 13.702 15.49 13.022H15.4896ZM9.62404 6.54054C9.62404 8.24058 8.24094 9.62363 6.54082 9.62363C4.8407 9.62363 3.45759 8.24058 3.45759 6.54054C3.45759 4.84049 4.8407 3.45745 6.54082 3.45745C8.24094 3.45745 9.62404 4.84049 9.62404 6.54054Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgSearchFilled)
const IconSvgSearchFilled = createIcon(ForwardRef, 'SvgSearchFilled')
export default IconSvgSearchFilled
